export default __webpack_public_path__ + "static/media/bitcoin.b126b5e5.3ff2d62d.svg";